import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableExtensionDataError, RpcObservableExtensionDataKey, RpcObservableExtensionDataRequest, RpcObservableExtensionDataResult
} from './rpc-observable-extension-data-model';

export class RpcObservableExtensionDataServer
    extends RpcObservableServer<RpcObservableExtensionDataRequest, RpcObservableExtensionDataResult, RpcObservableExtensionDataError> {

    /**
     * Initializes a new instance of the RpcObservableExtensionDataServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableExtensionDataKey.command, RpcObservableExtensionDataKey.version);
    }
}
